export default [
  { label: 'Deutschland', value: 'DE' },
  { label: 'Anderes Land', value: 'OTHER' }
]
